import React, { useEffect, useState } from 'react'
import axios from 'axios';

const Contact = (props) => {

    useEffect(() => {
        document.title = 'AmanChauhan-Contact'
    })

    const openGmailCompose = () => {
        const recipient = 'caman860@gmail.com';
        const mailtoLink = `mailto:${recipient}`;
        window.location.href = mailtoLink;
    };

    const [formData, setFormData] = useState({
        Name: '',
        Email: '',
        Select: '',
        'Textarea': '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const { Name, Email, Select, Textarea } = formData;
        return Name.trim() !== '' && Email.trim() !== '' && Select.trim() !== '' && Textarea.trim() !== '';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const isValid = validateForm();

        if (!isValid) {
            props.showAlert('Please fill in all fields', 'rgb(255, 68, 68)');
            return;
        }

        try {
            await axios.post('https://portfolio-backend-aman-lxx8.onrender.com/send-email', formData);
            props.showAlert('Email Sent Successfully', 'rgb(28,170,28)');

            setFormData({
                Name: '',
                Email: '',
                Select: '',
                'Textarea': '',
            });
        } catch (error) {
            if (error.response) {
                props.showAlert('Server Error Occurred!', 'rgb(255, 68, 68)');
            } else if (error.request) {
                props.showAlert('Network Error Occurred!', 'rgb(255, 68, 68)');
            } else {
                props.showAlert('Error Occurred!', 'rgb(255, 68, 68)');
            }
        }
    };

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loader = document.getElementById("preloader");

        const handleLoad = () => {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            if (loader) {
                loader.style.display = "none";
            }
        };

        const isMobile = window.innerWidth <= 840;

        if (isMobile) {
            handleLoad();  // Directly call handleLoad for mobile devices
        } else if (document.readyState === 'complete') {
            // If the document is already loaded, call handleLoad immediately
            handleLoad();
        } else {
            window.addEventListener("load", handleLoad);
        }

        return () => {
            window.removeEventListener("load", handleLoad);
        };
    }, []); // Empty dependency array means this effect runs once on component mount


    return (
        <>

            {loading ? (
                <div id="preloader" className='preloader'>
                    <img src="../IMG/Aman.png" className='preload-img' alt="AMAN CHAUHAN" />
                    <h2 className='preload-heading'>AMAN CHAUHAN</h2>
                </div>
            ) :
                <>
                    <section id="Contact">
                        <div className="Contact--container">
                            <div className="Contact--info">
                                <div className="Contact--tagline">
                                    <p data-aos="fade-right" data-aos-duration="1000">Let's Work</p>
                                    <p data-aos="fade-right" data-aos-duration="1050">Together ?</p>
                                </div>
                                <div className="Contact--Contact" data-aos="fade-right" data-aos-duration="1100">
                                    <span className="Contact--bar"></span>
                                    <span>Contact</span>
                                </div>
                                <div className="Contact--procedure" data-aos="fade-right" data-aos-duration="1150">
                                    <p>Fill in the form or just use my contacts below. If you need my assist in a project, let's work on it!</p>
                                </div>
                                <button className="Contact--Email" onClick={openGmailCompose} data-aos="fade-right" data-aos-duration="1200">caman860@gmail.com</button>
                            </div>
                            <form className="Contact--form" onSubmit={handleSubmit}>
                                <div className="mb-3 form-input" data-aos="fade-up" data-aos-duration="1000">
                                    <label htmlFor="Name" className="Input--label">Name</label>
                                    <input type="text" name="Name" id="Name" className="Name Input" placeholder="Enter your Name" onChange={handleChange} value={formData.Name} />
                                </div>
                                <div className="mb-3 form-input" data-aos="fade-up" data-aos-duration="1000">
                                    <label htmlFor="Email" className="Input--label">Email</label>
                                    <input type="email" name="Email" id="Email" className="Email Input" placeholder="Enter your Email" onChange={handleChange} value={formData.Email} />
                                </div>
                                <div className="mb-3 form-input" data-aos="fade-up" data-aos-duration="1000">
                                    <label htmlFor="Select" className="Input--label">What can I help you with?</label>
                                    <select className="form-select Input" aria-label="Default select example" name="Select" onChange={handleChange} value={formData.Select}>
                                        <option value="">Select one...</option>
                                        <option value="1">FullStack Web/App Development</option>
                                        <option value="2">ML/AI Development</option>
                                        <option value="3">Frontend Development</option>
                                        <option value="4">Backend Development</option>
                                    </select>
                                </div>
                                <div className="mb-3 form-input" data-aos="fade-up" data-aos-duration="1000">
                                    <label htmlFor="Textarea" className="Input--label">What would make you happy in this project?</label>
                                    <textarea name="Textarea" id="Textarea" cols="30" rows="10"
                                        placeholder="Share some words regarding the project goals" className="text-area-input" onChange={handleChange} value={formData.Textarea}></textarea>
                                </div>
                                <button type="submit" className="Contact--form--submit" data-aos="slide-up" data-aos-duration="1000" data-aos-delay="100"><p>Submit Form</p>  </button>
                            </form>
                        </div>
                    </section>

                    <section id="footer">
                        <div className="footer--content">
                            <div className="Footer--info">
                                <p data-aos="slide-up" data-aos-duration="1000">You can also find me on social media:</p>
                                <div className="Footer--links">
                                    <a href="https://www.linkedin.com/in/aman-chauhan-779955256/" target='__blank' data-aos="fade-right" data-aos-duration="1000">Linkedin</a>
                                    <a href="https://www.instagram.com/aman.chauhnn/" target='__blank' data-aos="fade-right" data-aos-duration="1000">Instagram</a>
                                </div>
                            </div>
                            <div className="Footer--Moreinfo">
                                <p data-aos="fade-up" data-aos-duration="1000">If you want to find out more about me check the page below:</p>
                                <button className="Moreinfo-btn" data-aos="fade-up" data-aos-duration="1000"><a href="/about">More About Me</a></button>
                            </div>
                        </div>
                        <div className="footer--Copyright">
                            Copyright &#169; 2023 Aman Chauhan. All rights reserved.
                        </div>
                    </section>

                </>
            }

        </>
    )
}

export default Contact